export const STANDARD_PRODUCT_SIZES = [
  "XS",
  "S",
  "M",
  "L",
  "XL",
  "XXL",
  "3XL",
  "4XL",
  "5XL",
  "6XL",
  "Custom Tailored",
];

export const SIZE_CHART_ROWS = [
  { size: "XS", uk: "4", bust: "32", waist: "26", hip: "36" },
  { size: "S", uk: "6", bust: "34", waist: "28", hip: "38" },
  { size: "M", uk: "8", bust: "36", waist: "30", hip: "40" },
  { size: "L", uk: "10", bust: "38", waist: "32", hip: "42" },
  { size: "XL", uk: "12", bust: "40", waist: "34", hip: "44" },
  { size: "XXL", uk: "14", bust: "42", waist: "36", hip: "46" },
  { size: "3XL", uk: "16", bust: "44", waist: "38", hip: "48" },
  { size: "4XL", uk: "18", bust: "46", waist: "40", hip: "50" },
  { size: "5XL", uk: "20", bust: "48", waist: "42", hip: "52" },
  { size: "6XL", uk: "22", bust: "50", waist: "44", hip: "54" },
];

const SIZE_ALIASES = {
  CUSTOM: "Custom Tailored",
  "CUSTOM TAILORED": "Custom Tailored",
  "CUSTOM-TAILORED": "Custom Tailored",
};

export function normalizeProductSizes(sizes, { fallback = true } = {}) {
  if (!Array.isArray(sizes) || sizes.length === 0) {
    return fallback ? [...STANDARD_PRODUCT_SIZES] : [];
  }

  const normalized = sizes
    .map((size) => String(size || "").trim())
    .filter(Boolean)
    .map((size) => SIZE_ALIASES[size.toUpperCase()] || size.toUpperCase())
    .filter((size, index, list) => list.indexOf(size) === index);

  const selected = new Set(normalized);
  return STANDARD_PRODUCT_SIZES.filter((size) => selected.has(size));
}

export function sizeTestId(size) {
  return size.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
}
